import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

// Models
import { User } from 'src/app/modules/account/models/user';
import { MetaData } from 'src/app/platform/models/utils';
import { ProductsData } from 'src/app/modules/products/models/products';

// Services
import { UiService } from 'src/app/platform/services/ui.service';
import { UserService } from 'src/app/modules/account/user.service';
import { PlatformService } from 'src/app/platform/services/platform.service';
import { ProductsService } from 'src/app/modules/products/products.service';
import { ProceduresService } from 'src/app/modules/procedures/procedures.service';
import { AccountsService } from 'src/app/modules/account/accounts.service';

@Component({
  selector: 'app-products-delete',
  templateUrl: './products-delete.component.html',
  styleUrls: ['./products-delete.component.scss']
})
export class ProductsDeleteComponent implements OnInit {
  public formData: FormGroup = new FormGroup({
    contract: new FormControl('', [Validators.required]),
    phone: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.required]),
    schedule: new FormControl('', [Validators.required]),
    reason: new FormControl('', [Validators.required]),
    comment: new FormControl('', [Validators.required]),
    contactByEmail: new FormControl(true, [Validators.required]),
    contactByPhone: new FormControl(true, [Validators.required])
  });
  private user: User;
  public contractsSelected = false;
  public contractsData: Array<ProductsData> = [];
  public reasonsData: Array<MetaData> = [];

  constructor(
    public dialog: MatDialogRef<ProductsDeleteComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      contract: ProductsData
    },
    private uiService: UiService,
    private userService: UserService,
    private platformService: PlatformService,
    private productsService: ProductsService,
    private accountsService: AccountsService,
    private proceduresService: ProceduresService,
  ) {
    this.userService.currentUser.subscribe((user) => {
      this.user = user;
    });
  }

  ngOnInit(): void {
    this.uiService.showSpinner(true);

    this.productsService.reasonsGet().then((success) => {
      this.reasonsData = success.result;

      this.uiService.showSpinner(false);

      if (this.data !== null && this.data.contract.id > 0){
        this.contractsSelected = true;
        this.formData.setValue({
          contract: this.data.contract.id,
          phone: this.user.phone,
          email: this.user.email,
          schedule: '',
          reason: '',
          comment: '',
          contactByEmail: true,
          contactByPhone: true,
        });
      } else {
        this.uiService.showSpinner(true);

        this.productsService.contractsGet().then((success) => {
          this.uiService.showSpinner(false);
          this.formData.setValue({
            contract: '',
            phone: this.user.phone,
            email: this.user.email,
            schedule: '',
            reason: '',
            comment: '',
            contactByEmail: true,
            contactByPhone: true,
          });

          success.result.registers.forEach((contract: ProductsData) => {
            if (contract.isRemovable) {
              this.contractsData.push(contract);
            }
          });

          if (this.contractsData.length <= 0) {
            this.dialog.close();
            this.uiService.dialogShow('Baja de productos', 'No dispones de productos que puedan ser dado de baja automáticamante. Si necesitas dar de baja algún servicio existente podes realizar una nueva gestión para solicitarlo.', 'info');
          }
        }).catch((error) => {
          this.uiService.showSpinner(false);
          this.dialog.close();
          this.uiService.dialogShow('Ups!', 'No es posible solicitar una baja en este momento (#0002). Estamos trabajando para solucionar el inconveniente.', 'alert');
        });
      }
    }).catch((error) => {
      this.uiService.showSpinner(false);
      this.dialog.close();
      this.uiService.dialogShow('Ups!', 'No es posible solicitar una baja en este momento (#0001). Estamos trabajando para solucionar el inconveniente.', 'alert');
    });
  }

  onCancel(): void {
    this.dialog.close();
  }

  onSubmit(): void {
    if (this.formData.valid) {
      this.uiService.showSpinner(true);

      this.productsService.contractsDelete(
        this.formData.get('contract')?.value,
        this.formData.get('reason')?.value,
        this.formData.get('comment')?.value,
        this.formData.get('phone')?.value,
        this.formData.get('email')?.value,
        this.formData.get('schedule')?.value,
        this.formData.get('contactByEmail')?.value,
        this.formData.get('contactByPhone')?.value
      ).then((result) => {
        if (result.status) {
          this.dialog.close();

          this.uiService.showSpinner(false);
          this.accountsService.accountsDataUpdate();
          this.productsService.contractsUpdate(true);
          this.proceduresService.proceduresUpdate(true);
          this.userService.updateData('unsuscribeServices', true);

          this.uiService.dialogShow('Baja solicitada', 'Recibimos correctamente tu solicitud de baja. Un asesor se comunicará en las próximas 48 horas hábiles. Tu número de gestión es: <p><h1>' + result.result.id + '</h1></p>', 'success');
        }
        else {
          this.uiService.showSpinner(false);
          this.uiService.dialogShow('Ups!', 'Hubo un inconveniente al intentar solicitar la baja del producto. Por favor intenta nuevamente.', 'error');
        }
      }, (error) => {
        this.uiService.showSpinner(false);
        this.uiService.dialogShow('Ups!', 'No es posible solicitar la baja del producto en este momento. Estamos trabajando para solucionar el inconveniente.', 'alert');
      });
    } else {
      this.formData.markAllAsTouched();
      this.uiService.showSnackBar('Algunos datos no están completos');
    }
  }

  formHasError(formcontrol: string, data: string): any {
    const fields: any = {
      contract: {
        required:  'Seleccioná un producto'
      },
      phone: {
        required:  'Ingresá un teléfono de contacto'
      },
      email: {
        required:  'Ingresá un email de contacto'
      },
      schedule: {
        required:  'Indicanos un horario de contacto'
      },
      reason: {
        required:  'Seleccioná un motivo'
      },
      comment: {
        required:  'Indicanos porqué queres darle de baja al producto'
      }
    };

    return this.platformService.formHasError(this.formData, fields, formcontrol, data);
  }
}
